// src/utils/environment.js
class Environment {
  static isElectron() {
    // Check for Electron in multiple ways
    if (typeof window !== "undefined") {
      return !!(
        window.process?.versions?.electron ||
        window.navigator?.userAgent?.toLowerCase()?.includes("electron") ||
        window.electronAPI
      );
    }
    return false;
  }

  static isStandalonePWA() {
    if (typeof window !== "undefined") {
      return (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true ||
        document.referrer.includes("android-app://")
      );
    }
    return false;
  }

  static isDesktopApp() {
    return this.isElectron() || this.isStandalonePWA();
  }

  static getPlatform() {
    if (this.isElectron()) {
      return "electron";
    } else if (this.isStandalonePWA()) {
      return "pwa";
    } else {
      return "web";
    }
  }

  static getPlatformInfo() {
    const platform = this.getPlatform();

    if (platform === "electron" && window.electronAPI) {
      return {
        platform: "electron",
        os: window.electronAPI.platform || "unknown",
        version: window.electronAPI.version || "1.0.0",
        isDesktop: true,
      };
    }

    return {
      platform,
      os: this.getOS(),
      version: "1.0.0",
      isDesktop: this.isDesktopApp(),
    };
  }

  static getOS() {
    if (typeof navigator === "undefined") return "unknown";

    const userAgent = navigator.userAgent;
    if (userAgent.includes("Win")) return "Windows";
    if (userAgent.includes("Mac")) return "macOS";
    if (userAgent.includes("Linux")) return "Linux";
    if (userAgent.includes("Android")) return "Android";
    if (
      userAgent.includes("iOS") ||
      userAgent.includes("iPhone") ||
      userAgent.includes("iPad")
    )
      return "iOS";
    return "unknown";
  }
}

export default Environment;
